import React from 'react';
// import { Checkbox } from '../../../components';
import './OrdersTable.scss';
import { Button } from '../../../components/Bootstrap';
import { OrdersListQuery_orders_orders as Order } from '../__generated__/OrdersListQuery';
import { format } from 'date-fns';
import { fullDateFormat } from '../utils';

interface OrdersTableRowProps {
  item: Order;
  onClickRefund(item: Order);
}

export class OrdersTableRow extends React.Component<OrdersTableRowProps> {
  onClickRefund = () => {
    this.props.onClickRefund(this.props.item);
  };

  render() {
    const { item } = this.props;

    let data: any = item;
    const options = data.items.map((option, i) => <li key={i}>{option.name}</li>);
    return (
      <tr>
        <td className='report-table-date-col'>{item.orderId}</td>
        <td className='report-table-open-close-col'>{item.orderNumber}</td>
        <td className='report-table-open-close-col'>{item.status}</td>
        <td>{format(new Date(item.date), fullDateFormat)}</td>
        <td>{item.customer}</td>
        <td>{item.isDelivery ? 'Delivery' : 'Pick-up'}</td>
        <td>{item.fulfillmentCenterName}</td>
        <td>
          <ul>{options}</ul>
        </td>
        <td>${item.total.toFixed(2)}</td>
        <td>
          {item.status === 'FULFILLED' && (
            <Button type='button' color='primary' className='btn--rounded-padded' onClick={this.onClickRefund}>
              Refund
            </Button>
          )}
        </td>
      </tr>
    );
  }
}
